import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from '../InputField';
import CheckboxField from '../CheckboxField';
import Spinner from '../Spinner';

const TransferSubscriptionForm = ({ handleSubmit, selected, loading }) => {
  return (
    <div>
      <Spinner showLoader={loading} />
      <form onSubmit={handleSubmit}>
        <Field component={InputField} name="new_pin" />
        <Field
          component={CheckboxField}
          name="rename"
          label="Rename Subscription"
        />
        <div className="transfer-sub-selected">
          <button className="btn btn-danger mar-t" disabled={loading}>
            Transfer
          </button>
          <span className="mar-l mar-t">Selected User: {selected.email}</span>
        </div>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.new_pin) {
    errors.new_pin = 'Required';
  }

  return errors;
};

export default reduxForm({
  form: 'TransferSubscriptionForm',
  validate,
})(TransferSubscriptionForm);
